import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing, colors } = theme;

export default createUseStyles(
  {
    root: {
      width: '100%',
      padding: 0,
      margin: 0,
      height: 'max-content',
      overflow: 'hidden',
    },
    open: {
      '& $content': {
        border: [1, 'solid', 'transparent'],
        borderTopColor: colors.borderSubtle,
      },
    },
    icon: {
      color: colors.iconPrimary,
    },
    clickable: {
      cursor: 'pointer',
    },
    label: {
      background: colors.backgroundSubtle01,
      borderBottomColor: 'transparent',
      boxSizing: 'border-box',
      padding: [spacing.sp04],
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: [1, 'solid', 'transparent'],
      width: '100%',
      zIndex: 2,
      position: 'relative',
    },
    content: {
      background: colors.backgroundSubtle01,
      display: 'flex',
      padding: [spacing.sp04],
      height: 'auto',
      position: 'relative',
    },
  },
  {
    name: 'Card',
  },
);
